import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { TitleContext } from "../components/Topbar";
import { AIAssistantProvider, useAIAssistant } from "../context/AIAssistantContext";
import { useLocation } from "react-router-dom";

const getTitle = (pathname: string) => {
  if (pathname.startsWith("/dashboard")) return "Dashboard";
  if (pathname.startsWith("/administrators")) return "Administrators";
  if (pathname.startsWith("/organizations")) return "Users of ARiA";
  if (pathname.startsWith("/users")) return "Users";
  if (pathname.startsWith("/customer-categories")) return "Risk Profiles";
  if (pathname.startsWith("/ap-archetypes")) return "AP Archetypes";
  if (pathname.startsWith("/whatsapp-manager")) return "Conversations";
  if (pathname.startsWith("/integration")) return "Integration Details";
  if (pathname.startsWith("/settings")) return "Settings";
  return "";
};

const LayoutContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [dynamicTitle, setDynamicTitle] = useState<string | null>(null);
  const { isAIAssistantOpen } = useAIAssistant();
  const location = useLocation();
  const title = getTitle(location.pathname);

  // Auto-collapse sidebar when AI Assistant opens
  React.useEffect(() => {
    if (isAIAssistantOpen && !isCollapsed) {
      setIsCollapsed(true);
    }
  }, [isAIAssistantOpen, isCollapsed]);

  return (
    <TitleContext.Provider value={{ dynamicTitle, setDynamicTitle }}>
      <div className="flex h-screen bg-[#f7f9fb]">
        <Sidebar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed((c) => !c)} />
        <div className={`flex-1 flex flex-col h-screen transition-all duration-300 ${isCollapsed ? 'ml-16' : 'ml-64'} ${isAIAssistantOpen ? 'mr-96' : ''}`}>
          {/* Fixed Topbar */}
          <div className="sticky top-0 z-30 bg-[#f7f9fb]">
            <Topbar title={title} />
          </div>
          {/* Scrollable main content */}
          <main className="flex-1 overflow-y-auto overflow-x-hidden p-4">{children}</main>
        </div>
      </div>
    </TitleContext.Provider>
  );
};

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <AIAssistantProvider>
      <LayoutContent>{children}</LayoutContent>
    </AIAssistantProvider>
  );
};

export default Layout; 